export default __webpack_public_path__ + "static/media/admin-icon.68c5d0d7.svg";